module.exports = __webpack_public_path__ + "img/17.5d3f9ec7.png";